import styled from 'styled-components';
import { Box } from '../Box/Box.js';

const Wrapper = styled(Box) `
  overflow: ${({ state }) => (state === 'entered' ? 'visible' : 'hidden')};
  max-height: ${({ state, maxHeight }) => state === 'entering' || state === 'entered' ? `${maxHeight}px` : '0'};
  transition-property: max-height;
  transition-duration: ${({ timeout }) => timeout}ms;
  transition-timing-function: cubic-bezier(0.5, 0, 0.25, 1);
`;
const InnerWrapper = styled(Box) `
  width: 100%;
`;

export { InnerWrapper, Wrapper };
